import React from "react";

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import NavbarTop from "../components/NavbarTop";
import Footer from "./Footer";
import CovidCards from "./CovidCards";

export default function CovidResources() {
  return (
    <div>
      <NavbarTop />
      <div
        className="page-header"
        style={{
          backgroundImage:
            "url(" +
            require("assets/img/sections/gerrit-vermeulen.jpg").default +
            ")",
          minHeight: "40vh",
        }}
      >
        <div className="" />
        <div className="content-center">
          <Container>
            <h1>
              Hello, <br />
              We are Svastha
            </h1>
          </Container>
        </div>
      </div>
      <CovidCards />
      <Footer />
    </div>
  );
}
